import { WpUser } from "./WpUser.js";

export class Plugins {
    constructor() {
        Object.defineProperty(window, 'tools', {
            enumerable: false,
            configurable: true,
            get: () => {
                console.warn("Deprecated: window.tools is deprecated. Use e5.Plugins instead.");
                return e5.Plugins;
            }
        });

        Object.defineProperty(e5.Plugins, 'debug', {
            enumerable: false,
            configurable: true,
            get: () => {
                console.warn("Deprecated: window.tools.debug is deprecated. Use e5.Debug instead.");
                return e5.Debug;
            }
        });

        e5.Plugins.active = (uid: string) => {
            console.warn("Deprecated: window.tools.active() is deprecated. Use e5.Debug.active() instead.");
            return e5.Debug.active(uid);
        };

        const meta = document.querySelector(`meta[name="e5-meta-config"]`) as HTMLElement;
        if (!meta) {
            console.error("Missing meta tag:", `meta[name="e5-meta-config"]`);
            return;
        }
        try {
            e5.Plugins.config = JSON.parse(meta.getAttribute("data-json"));
        } catch (error) {
            e5.Plugins.config = {} as any;
            console.error("Could not parse meta config json", error);
            return;
        }

        if (e5.Plugins.config.isLocalReal) {
            e5.Debug.add({
                uid: "e5-force-not-local",
                icon: "fal fa-arrows-split-up-and-left",
                tooltip: "Disable Local Detection",
                cookie: true
            });
        }

        if (
            e5.Plugins.config.isLocal
            && e5.Plugins.config.realeaseUrl) {
            const realeaseUrl = e5.Text.rtrim(e5.Plugins.config.realeaseUrl, "\/");
            const siteUrl = e5.Text.rtrim(e5.Plugins.config.siteUrl, "\/");
            e5.Debug.add({
                uid: "release-url",
                icon: "fal fa-globe",
                tooltip: "Release URL",
                url: window.location.href.replace(siteUrl, realeaseUrl)
            });
        }

        e5.Plugins.blocks = {};

        e5.console.enabled = e5.Plugins.config.isDebugging;
        console.log("[eventfive.wordpress-plugin] [Plugins]");
        e5.Debug.visible = e5.Plugins.config.isDebugging;

        e5.Plugins.user = new WpUser();

        window.dispatchEvent(new Event("e5-plugins-ready"));
        window.dispatchEvent(new Event("e5-blocks-ready"));
    }
}